<input
  #fileInput
  type="file"
  hidden
  [accept]="accept"
  [disabled]="disabled"
  (change)="selectFile($event)"
/>
<button mat-raised-button color="action" type="button" [disabled]="disabled" (click)="fileInput.click()">
  <mat-icon>upload_file</mat-icon>
  {{ buttonLabel }}
</button>
